import styled from '@emotion/styled';
import { nafColor } from '@nafcore/theme';
import { spacing } from '@naf/theme';
import { Text } from '@naf/text';
import { colors } from '@naf-simba/theme';

export const Header = styled(Text)`
  margin-bottom: ${spacing.space16};
`;

export const ChargingTagList = styled.ul`
  padding: 0;
  margin: 0;
  margin-top: ${spacing.space32};
  > *:first-child {
    padding-top: 0;
  }
  > *:not(:last-child) {
    border-bottom: 1px solid ${nafColor.neutral.neutral2};
  }
`;

export const ChargingTagItem = styled.li`
  display: flex;
  align-items: baseline;
  padding-bottom: ${spacing.space16};
  padding-top: ${spacing.space16};
`;

export const StyledCheck = styled.div`
  height: 20px;
  width: 20px;
  border-radius: 10px;
  background: ${colors.secondary[300]};

  display: flex;
  align-items: center;
  justify-content: center;

  margin-right: 12px;

  svg {
    color: ${colors.secondary[900]};
  }
`;

export const TextWrapper = styled.div`
  flex-direction: column;

  p {
    margin: 0;
  }
`;
